import { render, staticRenderFns } from "./TokenAmil.view.vue?vue&type=template&id=4be34104&scoped=true"
import script from "./TokenAmil.view.vue?vue&type=script&lang=js"
export * from "./TokenAmil.view.vue?vue&type=script&lang=js"
import style0 from "./TokenAmil.view.vue?vue&type=style&index=0&id=4be34104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be34104",
  null
  
)

export default component.exports